import differenceInCalendarDays from "date-fns/differenceInCalendarDays";
import { DrxBannerConfig } from "./types";

// NB: You can provide dates in any timezone
// NB: the dates are used to determine whether or not
// the banner will be shown - see getActiveBanners
// Banner will be shown if startDate <= today <= endDate
// Banners are displayed in array order (first = top)
// For dynamic text, use a function: text: () => `Dynamic ${value}`
// For route filtering, use URL Pattern API syntax:
//   "/checkout"       - exact match only
//   "/checkout{/*}?"  - matches /checkout and all child routes
// For Amplitude feature flags:
//   amplitudeFlag: { name: "flag-name", value: "on" }
//   amplitudeFlag: { name: "flag-name", value: ["on", "treatment"] }  // multiple values
export const BannerConfigs: DrxBannerConfig[] = [
  // ============================================
  // Levity US Holiday Delivery Banners 2025
  // ============================================

  // 12-22 December: Countdown to Christmas cutoff
  {
    id: "christmas-countdown-2025",
    data: {
      text: (today: Date = new Date()) => {
        const cutoffDate = new Date("2025-12-23"); // Dec 23 midnight
        const daysLeft = differenceInCalendarDays(cutoffDate, today);
        return `Don't miss out: You have <strong>${daysLeft} day${
          daysLeft !== 1 ? "s" : ""
        } left</strong> to order for pre-Christmas delivery (subject to approval)`;
      },
      type: "info-banner",
    },
    startDate: new Date("2025-12-12"), // Dec 12 midnight
    endDate: new Date("2025-12-22T23:59:59"), // Dec 22 end of day
    activeForBrands: ["levity"],
    activeOnRoutes: ["/checkout{/*}?"],
    amplitudeFlag: {
      name: "gro-3911-christmas-delivery-message",
      value: "on",
    },
  },

  // 23 December before 15:31: Last day message
  {
    id: "christmas-countdown-2025",
    data: {
      text: "Don't miss out: It's the last day to order for pre-Christmas delivery (subject to approval)",
      type: "info-banner",
    },
    startDate: new Date("2025-12-23"), // Dec 23 midnight
    endDate: new Date("2025-12-23T15:30:59-05:00"), // Dec 23 15:30:59 EST
    activeForBrands: ["levity"],
    activeOnRoutes: ["/checkout{/*}?"],
    amplitudeFlag: {
      name: "gro-3911-christmas-delivery-message",
      value: "on",
    },
  },

  // 23 December 15:31 - 25 December: Post-cutoff message
  {
    id: "christmas-countdown-2025",
    data: {
      text: "Orders placed today will be delivered after December 26 (subject to approval)",
      type: "info-banner",
    },
    startDate: new Date("2025-12-23T15:31:00-05:00"), // Dec 23 15:31
    endDate: new Date("2025-12-25T23:59:59"), // Dec 25 end of day
    activeForBrands: ["levity"],
    activeOnRoutes: ["/checkout{/*}?"],
    amplitudeFlag: {
      name: "gro-3911-christmas-delivery-message",
      value: "on",
    },
  },

  // 26-30 December: May not arrive before Dec 31
  {
    id: "christmas-countdown-2025",
    data: {
      text: "Orders placed today may not arrive before December 31 (subject to approval)",
      type: "info-banner",
    },
    startDate: new Date("2025-12-26"), // Dec 26 midnight
    endDate: new Date("2025-12-30T23:59:59"), // Dec 30 end of day
    activeForBrands: ["levity"],
    activeOnRoutes: ["/checkout{/*}?"],
    amplitudeFlag: {
      name: "gro-3911-christmas-delivery-message",
      value: "on",
    },
  },

  // 31 December - 1 January: Post New Year delivery
  {
    id: "christmas-countdown-2025",
    data: {
      text: "Orders placed today will be delivered after January 2 (subject to approval)",
      type: "info-banner",
    },
    startDate: new Date("2025-12-31T00:00"), // Dec 31 midnight
    endDate: new Date("2026-01-01T23:59:59"), // Jan 1 end of day
    activeForBrands: ["levity"],
    activeOnRoutes: ["/checkout{/*}?"],
    amplitudeFlag: {
      name: "gro-3911-christmas-delivery-message",
      value: "on",
    },
  },

  // ============================================
  // RocketRX & ZipHealth Holiday Delivery Banners 2025
  // ============================================

  // 12-22 December: Countdown to Christmas cutoff
  {
    id: "christmas-countdown-2025",
    data: {
      text: (today: Date = new Date()) => {
        const cutoffDate = new Date("2025-12-23"); // Dec 23 midnight
        const daysLeft = differenceInCalendarDays(cutoffDate, today);
        return `Don't miss out: You have <strong>${daysLeft} day${
          daysLeft !== 1 ? "s" : ""
        } left</strong> to order for pre-Christmas delivery (subject to approval)`;
      },
      type: "info-banner",
    },
    startDate: new Date("2025-12-12T00:00:00"), // Dec 12 midnight
    endDate: new Date("2025-12-22T23:59:59-05:00"), // Dec 22 end of day
    activeForBrands: ["rocketrx", "ziphealth"],
    activeOnRoutes: ["/checkout{/*}?"],
    amplitudeFlag: {
      name: "gro-3911-christmas-delivery-message",
      value: "on",
    },
  },

  // 23 December before 15:31: FedEx Overnight for Christmas
  {
    id: "christmas-countdown-2025",
    data: {
      text: "Don't miss out: Choose FedEx Overnight at checkout for pre-Christmas delivery (subject to approval)",
      type: "info-banner",
    },
    startDate: new Date("2025-12-23"), // Dec 23 midnight
    endDate: new Date("2025-12-23T15:30:59-05:00"), // Dec 23 15:30:59 EST
    activeForBrands: ["rocketrx", "ziphealth"],
    activeOnRoutes: ["/checkout{/*}?"],
    amplitudeFlag: {
      name: "gro-3911-christmas-delivery-message",
      value: "on",
    },
  },

  // 23 December 15:31 - 25 December: FedEx Overnight from Dec 26
  {
    id: "christmas-countdown-2025",
    data: {
      text: "Choose FedEx Overnight at checkout for delivery from December 26 (subject to approval)",
      type: "info-banner",
    },
    startDate: new Date("2025-12-23T15:31:00-05:00"), // Dec 23 15:31
    endDate: new Date("2025-12-25T23:59:59"), // Dec 25 end of day
    activeForBrands: ["rocketrx", "ziphealth"],
    activeOnRoutes: ["/checkout{/*}?"],
    amplitudeFlag: {
      name: "gro-3911-christmas-delivery-message",
      value: "on",
    },
  },

  // 26-30 December: FedEx Overnight before Dec 31
  {
    id: "christmas-countdown-2025",
    data: {
      text: "Choose FedEx Overnight at checkout for delivery before December 31 (subject to approval)",
      type: "info-banner",
    },
    startDate: new Date("2025-12-26T00:00:00"), // Dec 26 midnight
    endDate: new Date("2025-12-30T23:59:59"), // Dec 30 end of day
    activeForBrands: ["rocketrx", "ziphealth"],
    activeOnRoutes: ["/checkout{/*}?"],
    amplitudeFlag: {
      name: "gro-3911-christmas-delivery-message",
      value: "on",
    },
  },

  // 31 December - 1 January: Post New Year delivery
  {
    id: "christmas-countdown-2025",
    data: {
      text: "Orders placed today will be delivered after January 2 (subject to approval)",
      type: "info-banner",
    },
    startDate: new Date("2025-12-31T00:00:00"), // Dec 31 midnight
    endDate: new Date("2026-01-01T23:59:59"), // Jan 1 end of day
    activeForBrands: ["rocketrx", "ziphealth"],
    activeOnRoutes: ["/checkout{/*}?"],
    amplitudeFlag: {
      name: "gro-3911-christmas-delivery-message",
      value: "on",
    },
  },
];
